module.exports = __webpack_public_path__ + "static/media/fa-solid-900.e9a29cf6.ttf";